import { memo, useCallback } from 'react';

import type { ProposalListItem } from '../../lib/proposals/core/types';
import { NAV_SHORTCUT_LABELS } from './navShortcutLabels';
import { OnboardingActionCard } from './OnboardingActionCard';

interface OnboardingActionRowProps {
  action: ProposalListItem;
  isSelected: boolean;
  isNew: boolean;
  showShortcuts: boolean;
  onMouseDown: (id: number) => void;
  onClick: (id: number) => void;
}

export const OnboardingActionRow = memo(function OnboardingActionRow({
  action,
  isSelected,
  isNew,
  showShortcuts,
  onMouseDown,
  onClick,
}: OnboardingActionRowProps) {
  const handleMouseDown = useCallback(
    () => onMouseDown(action.id),
    [onMouseDown, action.id]
  );

  const handleClick = useCallback(
    () => onClick(action.id),
    [onClick, action.id]
  );

  return (
    <div className={`relative ${isNew ? 'proposal-enter' : ''}`}>
      {showShortcuts && isSelected && (
        <div className='absolute right-3 top-1/2 -translate-y-1/2 z-10 flex flex-col gap-0.5 items-center'>
          <span className='text-[10px] font-medium text-fg-tertiary bg-bg-tertiary px-1.5 py-0.5 rounded'>
            {NAV_SHORTCUT_LABELS.up}
          </span>
          <span className='text-[10px] font-medium text-fg-tertiary bg-bg-tertiary px-1.5 py-0.5 rounded'>
            {NAV_SHORTCUT_LABELS.down}
          </span>
        </div>
      )}
      <OnboardingActionCard
        action={action}
        isSelected={isSelected}
        isNew={isNew}
        onMouseDown={handleMouseDown}
        onClick={handleClick}
      />
    </div>
  );
});
